import { CSSProperties, useMemo } from "react";
import { OnboardingTheme } from "../../../theme/theme";

export const useReactiveStyle = (
  isDragActive: boolean,
  isDragAccept: boolean,
  isDragReject: boolean,
): CSSProperties => {
  return useMemo(() => {
    let style = {};

    const activeStyle = {
      border: "1px dashed",
      opacity: "0.5",
    };

    const acceptStyle = {
      border: `1px solid ${OnboardingTheme.genericVariables["upload-success"]}`,
    };

    const rejectStyle = {
      border: `1px solid ${OnboardingTheme.genericVariables["upload-error"]}`,
    };

    if (isDragActive) {
      style = { ...activeStyle };
    }
    if (isDragAccept) {
      style = { ...acceptStyle };
    }
    if (isDragReject) {
      style = { ...rejectStyle };
    }
    return style;
  }, [isDragActive, isDragReject, isDragAccept]);
};
